import api from "./api";

// POST /recuperarsenha
export const solicitarCodigoRecuperacao = async (email) => {
  const { data } = await api.post("/recuperarsenha", {
    email,
    token: "0",
  });
  return data;
};

// GET /recuperarsenha/:email/:token
export const validarCodigoRecuperacao = async (email, token) => {
  const { data } = await api.get(
    `/recuperarsenha/${encodeURIComponent(email)}/${encodeURIComponent(token)}`
  );
  return data;
};

// PUT /operador/senha/:idOperador
export const atualizarSenhaOperador = async (email, senha) => {
  try {
    const response = await api.put("/operadorsenha", { email, senha });

    console.log("Resposta da API:", response.data);
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar senha:", error?.response?.data || error.message);
    throw error;
  }
};

